import { render } from "./view_request.vue?vue&type=template&id=4579cdc2"
import script from "./view_request.vue?vue&type=script&lang=js"
export * from "./view_request.vue?vue&type=script&lang=js"

import "./view_request.vue?vue&type=style&index=0&id=4579cdc2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__